import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=870e2cbc&"
import script from "./SiteFooter.vue?vue&type=script&lang=js&"
export * from "./SiteFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports